import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_nfcn39gpwy: FaireCollectionEntity = {
  token: "pbc_nfcn39gpwy",
  type: "collection",
  name: "tea towels",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e8ac1ca7a83d4f81463d555e21edf54684b767c4e686df417db1616ad877ee65.jpeg",
  itemCount: 14,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:22.665Z",
    importedBy: "entity-db-import-collections",
  },
};
